<script lang="ts">
  import { createEventDispatcher, onMount, tick } from "svelte";
  import FolderProject from "../../../lib/icons/FolderProject.svelte";

  export let briefName = "";
  export let isNew = false;

  const dispatch = createEventDispatcher();

  let titleInput: HTMLTextAreaElement | undefined;

  onMount(async () => {
    await tick();
    titleInput?.focus();
  });

  function handleNext() {
    if (briefName.trim()) {
      dispatch('navigate', { dir: 'next', answer: briefName });
    }
  }

  function handleBack() {
    dispatch('navigate', { dir: 'prev', answer: briefName });
  }

  function handleKeydown(e: KeyboardEvent) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleNext();
    }
  }
</script>

<div class="ui form">
  <div class="brief-question">
    {isNew ? 'Brief Name' : 'Edit Brief Name'}
  </div>

  <div class="field relative title-field">
    <textarea
      bind:this={titleInput}
      bind:value={briefName}
      placeholder="Enter your brief name here..."
      required
      rows="1"
      class="brief-textarea brief-textarea-step-1 input_bg resize-none"
      on:keydown={handleKeydown}
    ></textarea>
    <div class="absoulte brief-bubble bottom-full bubble bubble-top flow-center align-center padding-1">
      <div class="flow-center bubble-content">
        <div>
          <FolderProject />
        </div>
        <p>{isNew ? "I see that you would like to start a new Built-to-Brief project. Let's give it a name" : "You can update your brief name here"}</p>
      </div>
    </div>
  </div>

  <div class="emspace h20 floatc"></div>

  <div class="ui">
    <button type="button" on:click={handleBack} class="ui circular icon button" aria-label="Previous step">
      <i class="angle left icon" aria-hidden="true"></i>
    </button>
    <button type="button" on:click={handleNext} class="ui circular button icon black right floated" aria-label="Next step">
      <i class="angle right icon" aria-hidden="true"></i>
    </button>
  </div>
</div>

<style>
  .brief-question {
    font-size: 1.5rem;
    font-weight: 500;
    color: var(--grey);
    margin-bottom: 1.5rem;
    line-height: 1.4;
  }

  .brief-textarea {
    width: 100%;
    min-height: 60px;
    padding: 1rem;
    font-size: 1.125rem;
    font-weight: 400;
    border: 2px solid var(--border-color);
    border-radius: 8px;
    transition: all 0.2s ease;
    resize: none;
    overflow: hidden;
  }

  .brief-textarea:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(5, 108, 242, 0.1);
  }

  .brief-textarea::placeholder {
    color: var(--grey-secondary);
    opacity: 0.6;
  }

  .title-field {
    min-height: 120px;
  }

  @media (max-width: 768px) {
    .brief-question {
      font-size: 1.25rem;
      margin-bottom: 1rem;
    }

    .brief-textarea {
      font-size: 1rem;
      padding: 0.875rem;
    }
  }
</style>

